const { default: strings } = require('strings');

export const getDefaultRecruiterOption = ({ currentUser }) => {
  const coachName = currentUser.personalInformation?.full_name;
  return {
    id: currentUser.id,
    full_name: `${strings.dailyPlan.filters.myDailyPlan} - ${coachName}`
  };
};
